import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { omit } from "lodash";
import { renderFieldView } from "../../components/fieldsViews/renderFieldView";
import { renderFieldInput } from "../../components/fieldsInputs/renderFieldInput";
import { GroupsTitle } from "../../components/groups/GroupsTitle";
import { FieldName } from "../../components/groups/FieldName";
import { getFieldExtraOption } from "../../utils/getFieldExtraOption";
import { Group } from "../../utils/formatGroups";
import { GroupsOptions } from "../../types/groups.types";
import { FieldExtraOption, FormatedField } from "../../types/fields.types";

// Mirrors Groups.tsx renderFieldByType so a single group renders identically to the framework
// (same Directus/extra-option visibility rules, and defaultValue only on create).
const renderFieldByType = (
	type: string,
	field: FormatedField,
	item: any,
	entityForm: UseFormReturn | undefined,
	fieldExtraOptions: FieldExtraOption | null
) => {
	if (field.settings.hidden) return null;

	const isOptionsHiddenOn = fieldExtraOptions?.hidden;

	if (type === "detail") {
		if (isOptionsHiddenOn?.detail || isOptionsHiddenOn?.detailFn?.(item)) return null;
		return (
			<>
				<FieldName headerName={field.headerName} />
				{renderFieldView(field, item, "group", fieldExtraOptions)}
			</>
		);
	}

	if (type === "update") {
		if (isOptionsHiddenOn?.update || isOptionsHiddenOn?.updateFn?.(item)) return null;
		const updateExtraOptions = fieldExtraOptions ? omit(fieldExtraOptions, "defaultValue") : null;
		return entityForm && renderFieldInput(field, item, "group", entityForm, updateExtraOptions);
	}

	if (isOptionsHiddenOn?.create) return null;
	return entityForm && renderFieldInput(field, null, "group", entityForm, fieldExtraOptions);
};

type DynamicTasksGroupBlockProps = {
	group: Group;
	item: any;
	type: string;
	entityForm?: UseFormReturn;
	groupsOptions?: GroupsOptions;
	hideTitle?: boolean;
};

export const DynamicTasksGroupBlock = ({ group, item, type, entityForm, groupsOptions, hideTitle }: DynamicTasksGroupBlockProps) => {
	return (
		<>
			{!hideTitle && <GroupsTitle title={group.groupName} />}
			<TableContainer>
				<Table>
					<TableBody>
						{group.fields.map((field) => {
							const extraOptions = groupsOptions?.fieldsWithExtraOptions;
							const fieldExtraOptions = extraOptions ? getFieldExtraOption(extraOptions, field) : null;
							const renderedField = renderFieldByType(type, field, item, entityForm, fieldExtraOptions);
							if (!renderedField) return null;
							return (
								<TableRow key={field.field}>
									<TableCell sx={{ maxWidth: 400, border: "0px", paddingLeft: 0, paddingTop: 2 }} align="left">
										{renderedField}
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
